import { Box, CircularProgress } from "@mui/material"
import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"
import type { FC } from "react"

import { TransferFormPage } from "@/screens/Inventory/subfeatures/Transfers/components/TransferFormPage/TransferFormPage"
import { useGetTransferWarehouse } from "@/screens/Inventory/subfeatures/Transfers/hooks/useGetTransferWarehouse"
import { transferLaunchFormSchema } from "@/screens/Inventory/subfeatures/Transfers/schemas/transfer"

const TransferCreatePage: FC = () => {
  const { type, sourceWarehouseAreaId, targetWarehouseAreaId } = Route.useSearch()
  const { warehouseArea: sourceWarehouseArea, isFetching: isFetchingSourceWarehouseArea } =
    useGetTransferWarehouse(sourceWarehouseAreaId)
  const { warehouseArea: targetWarehouseArea, isFetching: isFetchingTargetWarehouseArea } =
    useGetTransferWarehouse(targetWarehouseAreaId)

  if (!sourceWarehouseArea || (targetWarehouseAreaId && !targetWarehouseArea)) {
    return (
      <Box className='flex h-full items-center justify-center'>
        {(isFetchingSourceWarehouseArea || isFetchingTargetWarehouseArea) && <CircularProgress size={48} />}
      </Box>
    )
  }

  return (
    <TransferFormPage type={type} sourceWarehouseArea={sourceWarehouseArea} targetWarehouseArea={targetWarehouseArea} />
  )
}

export const Route = createFileRoute("/app/inventory/transfers/new")({
  validateSearch: zodValidator(transferLaunchFormSchema),
  component: TransferCreatePage,
})
